var normalizeComponent = require("!../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader?{\"babelrc\":\"/usr/src/apps/admin/package.json\",\"cacheDirectory\":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductVariants.vue"
import __vue_script__ from "!!babel-loader?{\"babelrc\":\"/usr/src/apps/admin/package.json\",\"cacheDirectory\":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductVariants.vue"
/* template */
import __vue_template__ from "!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b75f7b6c\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductVariants.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/products/ProductVariants.vue
// module id = 726
// module chunks = 5